import { DEFAULT_LOCALE, SUPPORTED_LOCALES, type Locale } from './types'

export function parseLocale(value: string | null | undefined): Locale {
  if (value && SUPPORTED_LOCALES.includes(value as Locale)) {
    return value as Locale
  }
  return DEFAULT_LOCALE
}

export function getLocaleFromUrl(search?: string): Locale {
  if (typeof window === 'undefined') {
    return DEFAULT_LOCALE
  }
  const query = search ?? window.location.search
  const params = new URLSearchParams(query)
  return parseLocale(params.get('language'))
}

export function setDocumentLang(locale: Locale): void {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale === 'zh' ? 'zh-CN' : locale
  }
}
